import * as t from "io-ts";
import { TypeOf } from "io-ts";
import { DateFromISOString } from "io-ts-types";

export const PdfFieldIO = t.type({
    name: t.string,
    alternativeName: t.union([t.string, t.undefined, t.null]),
    defaultValue: t.union([t.string, t.undefined, t.null]),
    type: t.string,
    isExported: t.boolean,
    isReadOnly: t.boolean,
    isRequired: t.boolean,
});

export type PdfField = TypeOf<typeof PdfFieldIO>;

// Template metadata information
export const TemplateFileIO = t.type({
    id: t.string,
    name: t.string,
    filename: t.string,
    originalFilename: t.union([t.string, t.undefined]),
    createdAt: DateFromISOString, // ISO string
    createdBy: t.string, // User UUID from JWT
    updatedAt: t.string, // DateFromISOString, // ISO string
    updatedBy: t.string, // User UUID from JWT
    size: t.number, // in byte
    fields: t.array(PdfFieldIO),
});

export const TemplateFileListIO = t.array(TemplateFileIO);

export type TemplateFile = TypeOf<typeof TemplateFileIO>;

export const TemplateUploadResponseIO = t.type({
    status: t.string, // should be "success"
    code: t.number, // should be 201
    filename: t.string, // File filename property
});

export type TemplateUploadResponse = TypeOf<typeof TemplateUploadResponseIO>;
